// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__3QxAt","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__24nVr"};